import { Card as CardBase } from 'theme-ui';

/**
 * @doc $DOC:Card
 */
export const Card = CardBase;
